<div class="box_default box_white add_user_group">
    <h3>{{group.name}}: Users</h3>
    <div class="loader">
      <div class="dimmed" *ngIf="status==STATUS_LOADING">
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
          <div class="dimmed_subtitle"></div>
        </div>
      </div>
      <!-- <core-helpers-box-loading *ngIf="status==STATUS_LOADING"></core-helpers-box-loading> -->
    </div>
    <div *ngIf="status==STATUS_DONE">
      <header>
          <div class="data-header">
            <div class="button-settings-add">
              <core-helpers-navigation-three-dots-menu
                [menu]="menu"
                (action)="onMenuClick($event)"
              ></core-helpers-navigation-three-dots-menu>
              <!-- <span (click)="showForm=!showForm">Add user to group</span> -->
            </div>
          </div>
          <!--<div class="instructions">
              <a (click)="showInstructions = !showInstructions" class="trigger" [ngClass]="{'opened' : showInstructions}"><em>How does this work?</em></a>
              <ol *ngIf="showInstructions">
                <li>Click <strong>REMOVE</strong> to remove a user from the group (this only deactivates them in the group, not as a <strong>SYSTEM USER</strong>)</li>
                <li>Click <strong>ADD USERS TO GROUP</strong> to select a user to be added to this user group.</li>
              </ol>
            </div> -->
      </header>
        <settings-groups-group-users-add-form
            [hidden]="!showForm"
            [group]="group"
            [existingUsers]="users"
            (cancel)="showForm=false"
            (submit)="loadUsers()"
        ></settings-groups-group-users-add-form>
      <ul>
        <core-helpers-lists-one-action-list-item
            *ngFor="let user of users | sortBy: 'name' : 'asc'"
            [title]="user.name"
            [actionText]="'Remove'"
            (actionClick)="remove(user)"
            [type]="'disabled'"
        ></core-helpers-lists-one-action-list-item>
        <!-- <li *ngFor="let user of users">
            <span>{{user.name}}</span> <a (click)="remove(user)">Remove</a>
        </li> -->
        </ul>

        <div [hidden]="users.length!=0">
            <p>No users belong to this group. Click <strong>Add user to group</strong> to get started.</p>
        </div>
    </div>
</div>
